import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=21bdea4a&scoped=true&"
import script from "./Clipboard.vue?vue&type=script&lang=js&"
export * from "./Clipboard.vue?vue&type=script&lang=js&"
import style0 from "./Clipboard.vue?vue&type=style&index=0&id=21bdea4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bdea4a",
  null
  
)

export default component.exports